/**
 * Chrome→body bridge: `TileFrame` (the chrome owner) provides the tile +
 * dashboardId so shared body states (`QueryTileStates`) can offer inline
 * recovery actions (Retry / Run now / Configure) without every tile view
 * threading extra props. `null` outside a framed dashboard tile (add-tile
 * preview, snapshot surfaces) — consumers must degrade to text-only states.
 */
import { createContext, useContext } from 'react';
import type { DashboardTile } from '../../types/dashboardTypes';

export type TileChrome = { dashboardId: string; tile: DashboardTile };

export const TileChromeContext = createContext<TileChrome | null>(null);

export const useTileChrome = (): TileChrome | null => useContext(TileChromeContext);
